import React, { Component, Fragment } from "react";
import styles from "./InfoScreenViewer.css";
import InfoCampaign from "../../components/InfoCampaign/InfoCampaign";
import InfoList from "../InfoList/InfoList";
import { TypeRoute } from "../../constants/consts-prop-types";
import { getPageData } from "../../services/service-wp";

const themes = {
  dark: {
    backgroundColor: "black",
    color: "white",
  },
  light: {
    backgroundColor: "white",
    color: "black",
  },
};

class InfoScreenViewer extends Component {
  static propTypes = {
    currentRoute: TypeRoute,
  };

  constructor(props) {
    super(props);

    this.renderComponentItem = this.renderComponentItem.bind(this);

    this.state = {
      activeIndex: 0,
      components: props.currentRoute.components,
    };

    this.interval = null;
    this.refreshInterval = null;
    const params = new URLSearchParams(document.location.search);
    this.screenCount = params.get("size") || 1;
  }

  componentDidMount() {
    const params = new URLSearchParams(document.location.search);

    if (params.get("type") === "2") {
      this.interval = setInterval(() => {
        const { activeIndex } = this.state;
        this.setState({
          activeIndex:
            activeIndex === this.screenCount - 1 ? 0 : activeIndex + 1,
        });
      }, 10000);
    }

    this.refreshInterval = setInterval(async () => {
      const newData = await getPageData(
        document.location.pathname,
        document.location.search
      );

      if (!newData) return;
      this.setState({
        components: newData.components,
      });
    }, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.refreshInterval);
  }

  extractComponentData(components) {
    const listComponentData = components.filter(
      (component) => component.component_id === "list_items"
    );
    if (listComponentData && listComponentData[0]) {
      return listComponentData[0];
    }
    if (components[0]) {
      return components[0];
    }
    return null;
  }

  renderComponentItem(componentData, type) {
    const { activeIndex } = this.state;

    if (componentData.items && type !== "2") {
      return (
        <InfoList currentRoute={this.props.currentRoute} data={componentData} />
      );
    } else if (componentData.items && type === "2") {
      return componentData.items.map((item, index) => {
        console.log({ item });
        return (
          <Fragment>
            {index === activeIndex && (
              <InfoCampaign
                key={index}
                currentRoute={this.props.currentRoute}
                data={item}
              />
            )}
          </Fragment>
        );
      });
    } else {
      return (
        <InfoCampaign
          currentRoute={this.props.currentRoute}
          data={componentData}
        />
      );
    }
  }

  render() {
    const componentData = this.extractComponentData(this.state.components);
    if (!componentData) return null;

    const params = new URLSearchParams(document.location.search);

    const pagePageSpecificStyles = {
      backgroundColor: componentData.colors
        ? componentData.colors.background
        : "",
      color: componentData.colors ? componentData.colors.foreground : "",
    };

    const styleColor = themes[params.get("theme")] || pagePageSpecificStyles;

    return (
      <div className={styles.InfoScreenViewer} style={styleColor}>
        {this.renderComponentItem(componentData, params.get("type"))}

        {/*<div
          className={styles.itemsContainer}
        >
          {components.map((itemData, idx) => {
            return (
              <div
                key={idx}
                className={currentIndex === idx ? styles.itemWrapperShow : styles.itemWrapper}
              >
                {this.renderComponentItem(itemData, idx, currentIndex)}
              </div>
            )
          })}
        </div>*/}
      </div>
    );
  }
}

export default InfoScreenViewer;



// WEBPACK FOOTER //
// ./src/components/InfoScreenViewer/InfoScreenViewer.js